<template>
  <form v-on:submit="submit" id="newEmployerForm" novalidate>
    <div class="form-group">
      <label>Company Name</label>
      <input
        v-model="employerData.name"
        type="text"
        class="form-control"
        id="name"
        placeholder="Company Name"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label for="personalPhone">Company Phone Number</label>
      <input
        v-model="employerData.phone"
        type="text"
        class="form-control"
        id="personalPhone"
        maxlength="12"
        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
        placeholder="Personal Phone (Format: 123-456-7890)"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="personalEmail">Company Email</label>
      <input
        v-model="employerData.email"
        type="email"
        class="form-control"
        id="companyEmail"
        placeholder="Company Email"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="about">Company Description</label>
      <input
        v-model="employerData.description"
        type="text"
        class="form-control"
        id="about"
        placeholder="What does your company do?"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <label for="about">Company Needs</label>
      <input
        v-model="employerData.needs"
        type="text"
        class="form-control"
        id="about"
        placeholder="What type of hires are you looking for?"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>
    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value id="invalidCheck" required />
        <label class="form-check-label" for="invalidCheck">Agree to terms and conditions</label>
        <div class="invalid-feedback">You must agree before submitting.</div>
      </div>
    </div>
    <button class="btn btn-primary" type="submit">Submit</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

export default {
  name: "newemployerform",
  components: {},
  data() {
    return {
      employerData: {
        name: "",
        description: "",
        phone: "",
        email: "",
        needs: ""
      }
    };
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    submit: function(event) {
      const form = document.getElementById("newEmployerForm");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity()) {
        const user = firebase.auth().currentUser;
        const userId = user.uid;
        const userName = user.displayName;
        const userEmail = user.email;

        const eData = this.employerData;
        const finalEmployerData = {
          name: eData.name,
          type: "employer",
          email: eData.email,
          phone: eData.phone,
          description: eData.description,
          needs: eData.needs,
          addedByUser: { name: userName, email: userEmail, id: userId }
        };

        firebase
          .firestore()
          .collection("pendingOrganizations")
          .add(finalEmployerData)
          .then(ref => {
            if (ref.id) {
              firebase
                .firestore()
                .doc("users/" + userId)
                .set({
                  pendingNewOrg: ref.id
                })
                .then(() => {
                  $("#newEmployer").modal("hide");
                  location.reload();
                })
                .catch(function(error) {
                  console.error(error);
                });
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #50c7d9;
  border-color: #50c7d9 transparent #50c7d9 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
